import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";
import { useGroupStore } from "@/store/groupStore";
import { useIsAdmin, useLoginUser } from "../useAuth";
import { QUERY_KEYS } from "@/constants/QUERY_KEYS";

/**
 * Group Id 별로 캐싱함,
 * 이 엔드포인트는 Group ID 굳이 필요 없음
 *
 */

export type RosterConfigPresetSummary = {
  day_req: number;
  eve_req: number;
  nig_req: number;
  off_days: number;
  weekly_off_group: boolean;
  fixed_wanted_use_yn: boolean;
  use_mid: boolean;
};

export type RosterConfigLastApplied = {
  year: number;
  month: number;
  schedule_version: number;
};

export type RosterConfigPreset = {
  config_id: number;
  version: number;
  config_name: string | null;
  config_memo: string | null;
  summary: RosterConfigPresetSummary;
  last_saved_at: string | null;
  last_applied: RosterConfigLastApplied | null;
};

export type RosterConfigVersionsResponse = RosterConfigPreset[];

export function resolveRosterConfigGroupId(
  selectedGroupId?: string | null,
  loginGroupId?: string | null
): string | null {
  const selected = selectedGroupId?.trim();
  if (selected) return selected;

  const authenticated = loginGroupId?.trim();
  return authenticated || null;
}

export function useRosterConfigVersionsQuery(options?: { enabled?: boolean }) {
  const { selectedGroupId } = useGroupStore();
  const isAdmin = useIsAdmin();
  const loginUser = useLoginUser();

  const effectiveGroupId = resolveRosterConfigGroupId(
    isAdmin ? selectedGroupId : null,
    loginUser?.group_id
  );

  return useQuery({
    queryKey: QUERY_KEYS.config.rosterConfigVersions(effectiveGroupId ?? ""),
    queryFn: () =>
      httpClient.get<RosterConfigVersionsResponse>("/roster/config/versions", {
        params: effectiveGroupId ? { group_id: effectiveGroupId } : undefined,
      }),
    enabled: (options?.enabled ?? true) && effectiveGroupId != null,
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 1000,
  });
}
